import { User } from "@/services/user-service";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AlertTriangle } from "lucide-react";

interface DeleteUserDialogProps {
  user: User | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: (userId: string) => void;
}

export function DeleteUserDialog({ user, open, onOpenChange, onDelete }: DeleteUserDialogProps) {
  if (!user) return null;

  const handleDelete = () => { onDelete(user.id); onOpenChange(false); };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader className="border-b pb-2">
          <DialogTitle className="text-sm font-semibold uppercase tracking-wide flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-4 w-4" />
            Excluir Usuário
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3 py-2">
          <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-3">
            <p className="text-xs text-destructive font-medium">
              Atenção: Esta ação é irreversível. Todos os dados do usuário serão permanentemente removidos do sistema.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1">
              <Label className="filter-label" htmlFor="name">Nome</Label>
              <Input className="filter-input" id="name" value={user.name} disabled />
            </div>
            <div className="space-y-1">
              <Label className="filter-label" htmlFor="email">E-mail</Label>
              <Input className="filter-input" id="email" value={user.email} disabled />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1">
              <Label className="filter-label" htmlFor="cellPhone">Telefone</Label>
              <Input className="filter-input" id="cellPhone" value={user.cellphone} disabled />
            </div>
            <div className="space-y-1">
              <Label className="filter-label" htmlFor="role">Função</Label>
              <Input className="filter-input" id="role" value={user.role} disabled />
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-3 border-t">
          <Button variant="outline" size="sm" className="btn-header" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button variant="destructive" size="sm" className="btn-header" onClick={handleDelete}>Excluir Usuário</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
